import moment from "moment"
import Service from "../../../Services/index"

const BillingPayoff = {
    namespaced: true,
    state: {
        billingPayoffs: [],
        customer_billing: [],
        billingPayoffCounts: {
            all: 0,
            cash: 0,
            transfer: 0,
            cheque: 0,
            cancelled: 0
        },
        billingPayoffForm: {
            seller_id: null,
            customer: null,
            transaction_type_id: null,
            receive_date: null,
            is_sell: true,
            calc_tax: 0,
            offset_amount: 0,
            pledge_amount: 0,
            fee_amount: 0,
            tax_amount: 0,
            transactions: [
                {
                    transaction_type_id: "",
                    ref_no: "",
                    date: "",
                    amount: "",
                    description: "",
                    bank_name: "",
                    bank_branch: ""
                }
            ],
            detail: [],
            sumTotalPrice: 0,
            sumAwaitPayoff: 0
        },
        billingsByCustomers: [],
        search: {
            seller_id: null,
            customer: null,
            transaction_type_id: null,
            cancelled: false,
            start_date: null,
            end_date: null
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        }
    },
    mutations: {
        SET_BILLING_PAYOFFS: (state, res) => {
            state.billingPayoffs = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        SET_BILLINGS_BY_CUSTOMER_ID: (state, data) => {
            state.billingsByCustomers = data
        },
        SET_FILTER_CANCELLED: (state, isCancelled) => {
            state.search.cancelled = isCancelled
        },
        SET_TRANSACTION_TYPE: (state, transactionType) => {
            state.search.transaction_type_id = transactionType
        },
        SET_BILLING_PAYOFF_COUNTS: (state, data) => {
            state.billingPayoffCounts = {
                ...data
            }
        },
        SET_SEARCH: (state, search) => {
            state.search = {
                ...state.search,
                ...search
            }
        },
        SET_CUSTOMER_BILLING: (state, res) => {
            state.customer_billing = res;
        },
        SET_DETAIL: (state, data) => {
            state.billingPayoffForm.detail = [{
                ...state.billingPayoffForm.detail,
                ...data
            }]
        },
        CLEAR_FORM_DATA: (state) => {
            state.billingPayoffForm = {
                seller_id: null,
                customer: null,
                transaction_type_id: null,
                receive_date: null,
                is_sell: true,
                calc_tax: 0,
                offset_amount: 0,
                pledge_amount: 0,
                fee_amount: 0,
                tax_amount: 0,
                transactions: [
                    {
                        transaction_type_id: "",
                        ref_no: "",
                        date: "",
                        amount: "",
                        description: "",
                        bank_name: "",
                        bank_branch: ""
                    }
                ],
                detail: [],
                sumTotalPrice: 0,
                sumAwaitPayoff: 0
            };
            state.billingsByCustomers = [];
        }
    },
    actions: {
        setBillingPayoffs({state, commit}) {
            return Service.BillingPayoff.getBillingPayoffs({
                page: state.current_page,
                ...state.search
            })
                .then(data => {
                    commit("SET_BILLING_PAYOFFS", data)
                })
        },
        setBillingByCustomerId({commit}, customerIds) {
            if (!customerIds.length) {
                return commit("SET_BILLINGS_BY_CUSTOMER_ID", [])
            }
            return Service.Billing.getBillingsByCustomerId(customerIds)
                .then(data => {
                    commit("SET_BILLINGS_BY_CUSTOMER_ID", data)
                })
        },
        setBillingPayoffCounts({commit}) {
            return Service.BillingPayoff.getBillingPayoffCounts()
                .then(data => {
                    commit("SET_BILLING_PAYOFF_COUNTS", data)
                })
        },
        setTransactionType({commit}, transactionType) {
            switch (transactionType) {
                case 1:
                case 2:
                case 3:
                    commit('SET_TRANSACTION_TYPE', transactionType)
                    commit('SET_FILTER_CANCELLED', false)
                    break

                case 'cancelled':
                    commit('SET_TRANSACTION_TYPE', null)
                    commit('SET_FILTER_CANCELLED', true)
                    break

                default:
                    commit('SET_TRANSACTION_TYPE', null)
                    commit('SET_FILTER_CANCELLED', false)
                    break
            }
        },
        setSearch({commit}, search) {
            commit("SET_SEARCH", search)
        },
        createBillingPayoff({commit, state}) {
            let billingDetail = []
            for (const key of Object.keys(state.billingsByCustomers)) {
                billingDetail = [
                    ...billingDetail,
                    ...state.billingsByCustomers[key].map(bill => ({
                        billing_id: bill.id,
                        amount: bill.total_price
                    }))
                ]
            }
            let data = {
                seller_id: state.billingPayoffForm.seller_id,
                receive_date: moment(state.billingPayoffForm.receive_date).format("YYYY-MM-DD"),
                is_sell: state.billingPayoffForm.is_sell,
                calc_tax: state.billingPayoffForm.calc_tax,
                offset_amount: state.billingPayoffForm.offset_amount,
                pledge_amount: state.billingPayoffForm.pledge_amount,
                fee_amount: state.billingPayoffForm.fee_amount,
                tax_amount: state.billingPayoffForm.tax_amount,
                detail: billingDetail,
                transactions: state.billingPayoffForm.transactions,
                customer: state.customer_billing
            };
            //console.log(data);
            return Service.BillingPayoff.createBillingPayoff(data)
        },
        cancelBillingPayoff(context, billingPayoffId) {
            return Service.BillingPayoff.deleteBillingPayoff(billingPayoffId)
        },
        setCustomerByBilling({commit}) {
            return Service.BillingPayoff.getCustomerByBilling().then(response => {
                commit("SET_CUSTOMER_BILLING", response)
            })
        },
        clearFormData({commit}) {
            commit("CLEAR_FORM_DATA");
        },
        setDetail({commit}, data) {
            commit("SET_DETAIL", data);
        }
    }
}

export default BillingPayoff
